export default __webpack_public_path__ + "static/media/Maskgroup.eeae7f59.svg";